import { ArrowRight } from "lucide-react";
import { SlideFrame, SlideHeader, Reveal } from "@/components/presentation/slides/SlideFrame";
import { MediaPlaceholder } from "@/components/primitives/MediaPlaceholder";
import { Button } from "@/components/primitives/Button";

/**
 * 01 · HeroSlide
 *
 * Opens a chapter (or the whole presentation) with maximum confidence:
 * one big idea + one large visual + a single primary action.
 *
 * Props are entirely optional — defaults render a calm placeholder.
 */
export const HeroSlide = ({
  eyebrow = "Eyebrow",
  title = "A single headline that carries the moment.",
  lede = "One supporting paragraph that completes the thought without adding a second one.",
  visualLabel = "Hero visual",
  continueLabel = "Continue",
  onContinue,
}) => {
  return (
    <SlideFrame testId="slide-hero">
      <SlideHeader
        eyebrow={eyebrow}
        title={title}
        lede={lede}
        size="xl"
        align="center"
      />
      <Reveal delay={3}>
        <MediaPlaceholder
          kind="image"
          label={visualLabel}
          ratio="16/9"
          testId="hero-visual"
        />
      </Reveal>
      {onContinue && (
        <Reveal delay={4} className="flex justify-center">
          <Button
            variant="primary"
            size="lg"
            onClick={onContinue}
            iconRight={<ArrowRight className="h-4 w-4" />}
            data-testid="hero-continue-button"
          >
            {continueLabel}
          </Button>
        </Reveal>
      )}
    </SlideFrame>
  );
};

export default HeroSlide;
